// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3eyUP","colMaxWidth":"Table_colMaxWidth__1sPLT"};